import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { CustomFieldType } from '../models';

export function useContractCustomFields(enabled: boolean) {
  const { data, ...arg } = useQuery<{ contractCustomFields: CustomFieldType[] }>(
    ['dashboard-v2-contract-custom-fields'],
    async () => {
      const { data } = await $api.get('/v1/contract/field');

      return { contractCustomFields: data?.data };
    },
    {
      enabled,
      staleTime: Infinity,
      cacheTime: Infinity
    }
  );

  return { ...data, ...arg };
}
